import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-6">
            <div className="text-center">
                <div className="label-tag">404</div>
                <h1 className="mt-4 font-display text-5xl md:text-6xl font-black">Page not found</h1>
                <p className="mt-4 text-white/70">The page you're looking for isn't here.</p>
                <Link to="/" className="mt-8 inline-block px-7 py-3 rounded-full bg-gold-500 text-ink-900 font-bold uppercase tracking-wider text-sm">
                    Back Home
                </Link>
            </div>
        </div>
    );
}
